import businessCard from '../images/businessCard.png';
import leaflet from '../images/leaflet.png';
import booklet from '../images/booklet.png';
import poster from '../images/poster.png';
import sticker from '../images/sticker.png';
import souvenir from '../images/souvenir.png';
import table from '../images/table.png';
import design from '../images/design.png';
import banner from '../images/banner.png';
import catalog from '../images/catalog.png';
import mug from '../images/mug.png';
import folder from '../images/folder.png';
import postcard from '../images/postcard.png';
import discountCard from '../images/discountCard.png';
import label from '../images/label.png';

export const CONTACTS = {
    company: '4 Цвета',
    city: 'Томск',
    address: 'г. Томск, ул. Большая Подгорная, 61/1',
    phone: '783-064',
    mobile: '+7 952 176-28-28',
    email: '4zveta@mail.ru',
    vk: 'https://vk.ru/4zveta',
    mapUrl: 'https://yandex.ru/map-widget/v1/?um=constructor%3Ad2b85b5045d3f9625a2c76203a4c6eff9ff2e2b246a59f775f0c01566b7a3827&source=constructor',
};

export const SERVICE_GROUPS = [
    {
        title: 'Деловая полиграфия',
        description: 'Визитки, бланки, папки, сертификаты и другие материалы для ежедневной работы компании.',
        image: businessCard,
        route: '/services',
        exampleCategory: 'Деловая полиграфия',
        items: ['Визитки', 'Бланки', 'Папки', 'Сертификаты'],
    },
    {
        title: 'Рекламная печать',
        description: 'Листовки, буклеты, каталоги, плакаты и афиши для акций, событий и презентаций.',
        image: leaflet,
        route: '/services',
        exampleCategory: 'Рекламная печать',
        items: ['Листовки', 'Буклеты', 'Каталоги', 'Плакаты'],
    },
    {
        title: 'Широкоформат и наружная реклама',
        description: 'Баннеры, стенды, таблички, вывески и навигационные элементы для помещений и улицы.',
        image: banner,
        route: '/services',
        exampleCategory: 'Широкоформат и наружная реклама',
        items: ['Баннеры', 'Стенды', 'Таблички', 'Вывески'],
    },
    {
        title: 'Наклейки и этикетки',
        description: 'Наклейки, стикеры, этикетки, ценники и маркировка для товаров, упаковки и мероприятий.',
        image: sticker,
        route: '/services',
        exampleCategory: 'Наклейки и этикетки',
        items: ['Наклейки', 'Этикетки', 'Ценники'],
    },
    {
        title: 'Сувенирная продукция',
        description: 'Печать на кружках, ручках, футболках, флешках и других фирменных носителях.',
        image: souvenir,
        route: '/services',
        exampleCategory: 'Сувенирная продукция',
        items: ['Кружки', 'Ручки', 'Футболки', 'Флешки'],
    },
    {
        title: 'Макеты и дизайн',
        description: 'Разработка, доработка и проверка макетов перед печатью, подготовка файлов к производству.',
        image: design,
        route: '/layouts_and_design',
        exampleCategory: 'Другое',
        items: ['Дизайн', 'Верстка', 'Подготовка макета'],
    },
];

export const FEATURED_PRODUCTS = [
    {name: 'Визитки', category: 'Деловая полиграфия', exampleCategory: 'Деловая полиграфия', image: businessCard},
    {name: 'Листовки', category: 'Рекламная печать', exampleCategory: 'Рекламная печать', image: leaflet},
    {name: 'Буклеты', category: 'Рекламная печать', exampleCategory: 'Рекламная печать', image: booklet},
    {name: 'Плакаты', category: 'Широкоформатная печать', exampleCategory: 'Широкоформат и наружная реклама', image: poster},
    {name: 'Наклейки', category: 'Маркировка и упаковка', exampleCategory: 'Наклейки и этикетки', image: sticker},
    {name: 'Каталоги', category: 'Многостраничная продукция', exampleCategory: 'Рекламная печать', image: catalog},
    {name: 'Кружки', category: 'Сувенирная продукция', exampleCategory: 'Сувенирная продукция', image: mug},
    {name: 'Папки', category: 'Деловая полиграфия', exampleCategory: 'Деловая полиграфия', image: folder},
    {name: 'Открытки', category: 'Печатная продукция', exampleCategory: 'Рекламная печать', image: postcard},
    {name: 'Дисконтные карты', category: 'Пластиковые карты', exampleCategory: 'Деловая полиграфия', image: discountCard},
    {name: 'Таблички', category: 'Навигация', exampleCategory: 'Широкоформат и наружная реклама', image: table},
    {name: 'Этикетки', category: 'Маркировка', exampleCategory: 'Наклейки и этикетки', image: label},
];

